/* Rotas por hash (#/secao/pagina), render das telas e despacho das ações dos elementos. */

import { carregaCatalogo } from './core/catalogo';
import { state } from './core/estado';
import { PAGINAS } from './paginas';
import type { Acao, Pagina } from './paginas/pagina';
import { erroBox, loading } from './ui/componentes';
import { $ } from './ui/dom';
import { NAV, renderCrumbs, renderEnv, renderRail, renderSubnav, secao, secaoVisivel } from './ui/shell';

/** Ações disponíveis em todas as telas. */
const ACOES_GLOBAIS: Record<string, Acao> = {
  filtro: (el) => {
    const chave = el.dataset.chave as 'ano' | 'obra' | 'escopo';
    state.f[chave] = (el as HTMLSelectElement).value;
    render();
  },
};

let paginaAtual: Pagina | undefined;
let appAberto = false;

export const ir = (hash: string) => {
  location.hash = hash;
};

export function abrirApp(): void {
  appAberto = true;
  rota();
}

export function fecharApp(): void {
  appAberto = false;
}

export function rota(): void {
  if (!appAberto) return;
  const [sec, page] = (location.hash || '#/painel').replace(/^#\//, '').split('/');
  // Seção sem permissão (ex.: Emissões para quem só consulta) cai no painel; antes do catálogo, ainda não dá para saber.
  const pedida = secao(sec);
  const s = pedida && (secaoVisivel(pedida) || !state.cat) ? pedida : NAV[0];
  state.sec = s.id;
  // Seção ou tela que não existe (ex.: link antigo) cai na tela inicial da seção.
  state.page = s.id === sec && page && PAGINAS[`${s.id}/${page}`] ? page : s.home;
  paginaAtual = PAGINAS[`${state.sec}/${state.page}`];
  renderRail();
  renderSubnav();
  renderCrumbs(paginaAtual?.titulo);
  renderEnv();
  render();
  $('#content').scrollTop = 0;
}

/** Desenha a tela atual. As telas que usam o catálogo esperam ele carregar. */
export function render(): void {
  const conteudo = $('#content');
  const tk = ++state.tk;
  const pagina = paginaAtual;
  if (!pagina) {
    conteudo.innerHTML = '<div class="empty"><h3>Página não encontrada</h3></div>';
    return;
  }
  if (!pagina.semCatalogo && !state.cat) {
    conteudo.innerHTML = loading('Carregando catálogo da empresa…');
    carregaCatalogo()
      .then(() => { if (tk === state.tk) render(); })
      .catch((e) => { if (tk === state.tk) conteudo.innerHTML = `<h1 class="page">Não foi possível carregar os dados</h1>${erroBox(e)}`; });
    return;
  }
  conteudo.innerHTML = pagina.render();
  pagina.carregar?.(tk);
}

function despachar(atributo: 'clique' | 'muda', ev: Event): void {
  const alvo = ev.target as HTMLElement | null;
  const el = alvo?.closest<HTMLElement>(`[data-${atributo}]`);
  if (!el) return;
  const nome = el.dataset[atributo] as string;
  const acao = paginaAtual?.acoes?.[nome] || ACOES_GLOBAIS[nome];
  if (!acao) {
    console.warn(`Ação sem tratador: ${nome}`);
    return;
  }
  if (atributo === 'clique') ev.preventDefault();
  void acao(el, ev);
}

/** Um ouvinte para a área de conteúdo inteira (os elementos são recriados a cada render). */
export function iniciarRoteador(): void {
  const conteudo = $('#content');
  conteudo.addEventListener('click', (ev) => despachar('clique', ev));
  conteudo.addEventListener('change', (ev) => despachar('muda', ev));
  window.addEventListener('hashchange', rota);
}
